import FormEditor from './FormEditor';

export default FormEditor;
